import TokenValidationContainer from './TokenValidationContainer';

export {
  TokenValidationContainer
};

export default TokenValidationContainer;
